"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.Dialog = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _core = require("@material-ui/core");

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _styles = require("@material-ui/core/styles");

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _excluded = ["children", "open", "onClose", "hideDialogActions"];

var styles = function styles(theme) {
  return {
    closeIcon: {
      padding: theme.spacing(2),
      textAlign: 'end',
      cursor: 'pointer'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      open = _ref.open,
      onClose = _ref.onClose,
      hideDialogActions = _ref.hideDialogActions,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var isMobile = (0, _core.useMediaQuery)(theme.breakpoints.down('xs'));
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, (0, _extends2["default"])({
    fullScreen: isMobile
  }, props, {
    open: open,
    onClose: onClose
  }), false === hideDialogActions && /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.closeIcon
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "close-icon",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.modalContainer
  }, children));
};

exports.Dialog = Dialog;
Dialog.defaultProps = {
  hideDialogActions: false
};
Dialog.propTypes = {
  /** If true, the modal is open. */
  open: _propTypes["default"].bool.isRequired,

  /** Callback fired when the component requests to be closed. */
  onClose: _propTypes["default"].func.isRequired,

  /** A single child content element. */
  children: _propTypes["default"].node.isRequired,

  /** hides the actions container */
  hideDialogActions: _propTypes["default"].bool
};
var _default = Dialog;
exports["default"] = _default;